<div class="modal-body main-font user-modal-wrapper">
  <div class="modal-content-container" *ngIf="workPlaceRequestForm">
    <div class="modal-header-container">
      <div class="row title-container">
        <p class="title-modal mb-0">Gestione presenze</p>
      </div>
      <hr />
    </div>

    <div class="modal-content-container" *ngIf="!isPartTimeUser">
      <ng-container>
        <p class="schedule-tab-title mb-0">
          Richiesta di modifica del luogo di lavoro
        </p>
        <p class="info">
          In base al tuo contratto, puoi usufruire di un massimo di 3 giorni di
          smart working a settimana, eccetto in caso di festività o smart
          working obbligatorio.
        </p>
        <div class="row col-12 mt-4">
          <div class="d-flex justify-content-end">
            <img
              class="wh-icone"
              src="assets/images/icon_request_modal/smart.svg"
              alt="" />
            <p class="info-smart-days">
              {{ totalSmartDays }}/{{ maxSmartDays }}
              giorni richiesti
            </p>
          </div>
        </div>

        <app-alert
          class="mt-3"
          message="Alcune richieste potrebbero essere rifiutate a causa della capienza limitata.">
        </app-alert>

        <form
          class="form-container tab-content"
          [formGroup]="workPlaceRequestForm">
          <div class="date-content row">
            <div class="week-selector">
              <button
                nz-button
                nzType="text"
                (click)="changeWeek(-1)"
                [disabled]="weekNavigationDisabled">
                <i nz-icon nzType="left"></i>
              </button>

              <div class="week-label mt-1">
                {{ formatWeek(currentWeekStart) }}
                <img
                  src="assets/images/icon_request_modal/calendar_grey.svg"
                  alt="" />
              </div>

              <button
                nz-button
                nzType="text"
                (click)="changeWeek(1)"
                [disabled]="weekNavigationDisabled">
                <i nz-icon nzType="right"></i>
              </button>
            </div>

            <div formGroupName="week">
              <div *ngIf="!isLoadingWeek">
                <div
                  *ngFor="let day of weekDays; let i = index"
                  class="day-row">
                  <div class="day-label">{{ day.label | uppercase }}</div>

                  <nz-select
                    [formControlName]="'day' + i"
                    class="day-select"
                    [nzDisabled]="
                      isPastDay(day.date) ||
                      day.label === 'venerdì' ||
                      isDayOff(i) ||
                      isPartTimeNonWorkingDay(i)
                    "
                    (ngModelChange)="updatePresentWorkers(i)"
                    [ngClass]="{ changed: isControlChanged(i) }">
                    <nz-option [nzValue]="14" nzLabel="Ufficio"></nz-option>
                    <nz-option
                      [nzDisabled]="totalSmartDays + 1 > maxSmartDays"
                      [nzValue]="2"
                      nzLabel="Remoto"></nz-option>
                    <nz-option
                      [nzDisabled]="totalSmartDays + 0.5 > maxSmartDays"
                      [nzValue]="3"
                      nzLabel="Smart mattina"></nz-option>
                    <nz-option
                      [nzDisabled]="totalSmartDays + 0.5 > maxSmartDays"
                      [nzValue]="4"
                      nzLabel="Smart pomeriggio"></nz-option>
                  </nz-select>

                  <div class="day-icon">
                    <span class="bubble">
                      <img
                        src="assets/images/icon_request_modal/seats.svg"
                        alt="" />{{ userWeek[i].present_users }} /
                      {{ userWeek[i].max_seats }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="note-container row">
            <p class="m-0 p-0 text-nate">Nota</p>
            <nz-textarea-count [nzMaxCharacterCount]="250">
              <textarea
                class="w-100"
                [nzAutosize]="{ minRows: 3, maxRows: 3 }"
                formControlName="note"
                nz-input
                (input)="limitTextLength()"
                placeholder="Scrivi il corpo dell'email per la richiesta">
              </textarea>
            </nz-textarea-count>
          </div>
        </form>
      </ng-container>
    </div>

    <mat-tab-group
      *ngIf="isPartTimeUser"
      class="user-modal-tabs"
      animationDuration="0ms"
      [selectedIndex]="activeTab === 'smart' ? 0 : 1"
      (selectedIndexChange)="setActiveTab($event === 0 ? 'smart' : 'schedule')">
      <mat-tab label="Smart working">
        <div class="modal-content-container">
          <p class="schedule-tab-title mb-0">
            Richiesta di modifica del luogo di lavoro
          </p>
          <p class="info">
            In base al tuo contratto, puoi usufruire di un massimo di 3 giorni
            di smart working a settimana, eccetto in caso di festività o smart
            working obbligatorio.
          </p>
          <div class="row col-12 mt-4">
            <div class="d-flex justify-content-end">
              <img
                class="wh-icone"
                src="assets/images/icon_request_modal/smart.svg"
                alt="" />
              <p class="info-smart-days">
                {{ totalSmartDays }}/{{ maxSmartDays }}
                giorni richiesti
              </p>
            </div>
          </div>

          <app-alert
            class="mt-3"
            message="Alcune richieste potrebbero essere rifiutate a causa della capienza limitata.">
          </app-alert>

          <form
            class="form-container tab-content"
            [formGroup]="workPlaceRequestForm">
            <div class="date-content row">
              <div class="week-selector">
                <button
                  nz-button
                  nzType="text"
                  (click)="changeWeek(-1)"
                  [disabled]="weekNavigationDisabled">
                  <i nz-icon nzType="left"></i>
                </button>

                <div class="week-label mt-1">
                  {{ formatWeek(currentWeekStart) }}
                  <img
                    src="assets/images/icon_request_modal/calendar_grey.svg"
                    alt="" />
                </div>

                <button
                  nz-button
                  nzType="text"
                  (click)="changeWeek(1)"
                  [disabled]="weekNavigationDisabled">
                  <i nz-icon nzType="right"></i>
                </button>
              </div>

              <div formGroupName="week">
                <div *ngIf="!isLoadingWeek">
                  <div
                    *ngFor="let day of weekDays; let i = index"
                    class="day-row">
                    <div class="day-label">{{ day.label | uppercase }}</div>

                    <nz-select
                      [formControlName]="'day' + i"
                      class="day-select"
                      [nzDisabled]="
                        isPastDay(day.date) ||
                        day.label === 'venerdì' ||
                        isDayOff(i) ||
                        isPartTimeNonWorkingDay(i)
                      "
                      (ngModelChange)="updatePresentWorkers(i)"
                      [ngClass]="{ changed: isControlChanged(i) }">
                      <nz-option [nzValue]="14" nzLabel="Ufficio"></nz-option>
                      <nz-option
                        [nzDisabled]="totalSmartDays + 1 > maxSmartDays"
                        [nzValue]="2"
                        nzLabel="Remoto"></nz-option>
                      <nz-option
                        [nzDisabled]="totalSmartDays + 0.5 > maxSmartDays"
                        [nzValue]="3"
                        nzLabel="Smart mattina"></nz-option>
                      <nz-option
                        [nzDisabled]="totalSmartDays + 0.5 > maxSmartDays"
                        [nzValue]="4"
                        nzLabel="Smart pomeriggio"></nz-option>
                    </nz-select>

                    <div class="day-icon">
                      <span class="bubble">
                        <img
                          src="assets/images/icon_request_modal/seats.svg"
                          alt="" />{{ userWeek[i].present_users }} /
                        {{ userWeek[i].max_seats }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="note-container row">
              <p class="m-0 p-0 text-nate">Nota</p>
              <nz-textarea-count [nzMaxCharacterCount]="250">
                <textarea
                  class="w-100"
                  [nzAutosize]="{ minRows: 3, maxRows: 3 }"
                  formControlName="note"
                  nz-input
                  (input)="limitTextLength()"
                  placeholder="Scrivi il corpo dell'email per la richiesta">
                </textarea>
              </nz-textarea-count>
            </div>
          </form>
        </div>
      </mat-tab>

      <mat-tab label="Distribuzione oraria">
        <div class="modal-content-container">
          <p class="schedule-tab-title mb-0">
            Richiesta di modifica dell’orario settimanale
          </p>
          <p class="schedule-tab-text mb-0">
            Puoi distribuire le tue ore settimanali sui 5 giorni lavorativi,
            mantenendo invariato il monte ore previsto dal tuo contratto.
          </p>

          <app-alert
            class="mt-3"
            [message]="
              'Hai a disposizione <b>' +
              partTimeWeeklyHours +
              ' ore </b> settimanali da distribuire nella settimana corrente.'
            ">
          </app-alert>

          <app-alert
            *ngIf="hasPendingScheduleRequest"
            class="mt-3 schedule-pending-alert"
            message="Per questa settimana è già presente una richiesta in attesa di approvazione. Le modifiche che inserisci aggiorneranno la stessa richiesta pending.">
          </app-alert>

          <form
            class="form-container tab-content"
            [formGroup]="scheduleRequestForm">
            <div class="date-content row">
              <div class="week-selector">
                <button nz-button nzType="text" (click)="changeWeek(-1)">
                  <i nz-icon nzType="left"></i>
                </button>

                <div class="week-label mt-1">
                  {{ formatWeek(currentWeekStart) }}
                  <img
                    src="assets/images/icon_request_modal/calendar_grey.svg"
                    alt="" />
                </div>

                <button nz-button nzType="text" (click)="changeWeek(1)">
                  <i nz-icon nzType="right"></i>
                </button>
              </div>

              <div class="schedule-section" formArrayName="weekly_schedule">
                <div
                  class="schedule-row"
                  *ngFor="let row of weeklyScheduleControls; let i = index"
                  [formGroupName]="i">
                  <div class="schedule-day">{{ row.get('label')?.value }}</div>

                  <div class="schedule-time any-form">
                    <nz-time-picker
                      formControlName="start_time"
                      nzFormat="HH:mm"
                      [nzDisabledHours]="disabledScheduleHours"
                      [nzDisabledMinutes]="disabledScheduleMinutes"
                      [nzDisabled]="!row.get('is_working_day')?.value"
                      nzPlaceHolder="00:00">
                    </nz-time-picker>
                  </div>

                  <div class="schedule-time any-form">
                    <nz-time-picker
                      formControlName="end_time"
                      nzFormat="HH:mm"
                      [nzDisabledHours]="disabledScheduleHours"
                      [nzDisabledMinutes]="disabledScheduleMinutes"
                      [nzDisabled]="!row.get('is_working_day')?.value"
                      nzPlaceHolder="00:00">
                    </nz-time-picker>
                  </div>

                  <div class="schedule-hours-pill">
                    {{
                      formatWorkingHours(row.get('working_minutes')?.value || 0)
                    }}
                  </div>

                  <label class="schedule-checkbox">
                    <input
                      type="checkbox"
                      [checked]="!row.get('is_working_day')?.value"
                      (change)="
                        onNonWorkingDayChange(i, $any($event.target).checked)
                      " />
                    <span>Non lavorativo</span>
                  </label>
                </div>

                <div *ngIf="isWeeklyScheduleInvalid()" class="schedule-error">
                  La distribuzione oraria deve coincidere con le ore
                  settimanali.
                </div>

                <div class="schedule-total">
                  Totale: {{ totalWeeklyScheduleHours }} hh
                </div>
              </div>
            </div>

            <div class="note-container row">
              <p class="m-0 p-0 text-nate">Nota</p>
              <nz-textarea-count [nzMaxCharacterCount]="250">
                <textarea
                  class="w-100"
                  [nzAutosize]="{ minRows: 3, maxRows: 3 }"
                  formControlName="note"
                  nz-input
                  (input)="limitScheduleNoteTextLength()"
                  placeholder="Scrivi il corpo dell'email per la richiesta">
                </textarea>
              </nz-textarea-count>
            </div>
          </form>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="modal-footer-container mt-4">
      <button class="primary-btn-outline-new w-100" (click)="closeModal()">
        Annulla
      </button>
      <button
        class="primary-btn-new w-100"
        *ngIf="!isPartTimeUser || activeTab === 'smart'"
        [disabled]="
          !(this.workPlaceRequestForm.valid && !this.weekNavigationDisabled)
        "
        (click)="saveWorkplaceRequest()">
        {{ 'Invia' }}
      </button>
      <button
        class="primary-btn-new w-100"
        *ngIf="isPartTimeUser && activeTab === 'schedule'"
        [disabled]="
          !scheduleRequestForm.valid ||
          isWeeklyScheduleInvalid() ||
          !hasScheduleWeekChanged()
        "
        (click)="savePartTimeWeekChangeRequest()">
        {{ 'Invia richiesta' }}
      </button>
    </div>
  </div>
</div>
